// ╔══════════════════════════════════════════════════════════════╗
// ║  Change password page                                          ║
// ╚══════════════════════════════════════════════════════════════╝

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { api, getErrorMessage } from '../lib/api.js';
import { useAuth } from '../lib/auth.jsx';
import { useToast } from '../components/Toast.jsx';
import { Btn, Card, Field, Input } from '../components/ui.jsx';

export default function ChangePasswordPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();
  const [form, setForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');

  const mut = useMutation({
    mutationFn: (payload) => api.post('/auth/change-password', payload),
    onSuccess: async () => {
      toast.push({
        tone: 'success',
        title: 'تم تغيير كلمة المرور',
        body: 'سيتم تسجيل الخروج. سجّل الدخول بكلمة المرور الجديدة.',
      });
      setTimeout(async () => {
        await logout();
        navigate('/login');
      }, 1500);
    },
    onError: (err) => setError(getErrorMessage(err)),
  });

  function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (form.newPassword !== form.confirmPassword) {
      setError('كلمتا المرور غير متطابقتين');
      return;
    }
    if (form.newPassword.length < 8) {
      setError('كلمة المرور الجديدة يجب ألا تقل عن 8 أحرف');
      return;
    }
    mut.mutate(form);
  }

  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div className="p-4 sm:p-6 lg:p-8 fade-up max-w-md">
      <div className="mb-5">
        <div className="text-[11px] uppercase tracking-[0.18em] text-brand-500 font-bold">
          الحساب
        </div>
        <h1 className="text-2xl md:text-3xl font-black mt-1">تغيير كلمة المرور</h1>
      </div>

      <Card className="p-6">
        {error && (
          <div className="mb-4 px-3 py-2.5 rounded-xl bg-rose-50 dark:bg-rose-950/30 text-rose-700 dark:text-rose-300 text-sm">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <Field label="كلمة المرور الحالية">
            <Input
              type="password"
              value={form.currentPassword}
              onChange={upd('currentPassword')}
              required
              autoComplete="current-password"
              dir="ltr"
            />
          </Field>
          <Field label="كلمة المرور الجديدة" hint="8 أحرف على الأقل">
            <Input
              type="password"
              value={form.newPassword}
              onChange={upd('newPassword')}
              required
              minLength={8}
              autoComplete="new-password"
              dir="ltr"
            />
          </Field>
          <Field label="تأكيد كلمة المرور الجديدة">
            <Input
              type="password"
              value={form.confirmPassword}
              onChange={upd('confirmPassword')}
              required
              autoComplete="new-password"
              dir="ltr"
            />
          </Field>
          <Btn type="submit" variant="primary" className="w-full" loading={mut.isPending}>
            تغيير كلمة المرور
          </Btn>
        </form>
      </Card>
    </div>
  );
}
